<template>
  <div>
    <div class="donation-area">
      <header class="main-header">
        <nav class="navbar navbar-default">
          <div class="container">
            <!-- Brand and toggle get grouped for better mobile display -->
            <div class="navbar-header">
              <a class="navbar-brand" href="#"><img src="static/assets/images/logo.png"></a>
            </div>              
              <ul class="nav navbar-nav navbar-right">
                <li><a href="https://nirman.mkcl.org/">Home</a></li>
                <li><a href="https://nirman.mkcl.org/people/net">Contact</a></li>
              </ul>
          </div><!-- /.container-fluid -->
        </nav>
      </header>
      <div class="main">
        <div class="container">
          <div class="donation-title-area d-flex align-items-center">
              <img src="static/assets/images/petals.png" class="img-leaf">
              <h2>Support the power of the youth</h2>
          </div>
          <div class="row clearfix d-flex align-items-start">
            <div class="col-sm-6 col-md-8" v-if="$route.params.status == 'success'">
                Congratulations! your payment for donation of Rs. {{$route.params.amount}} is successful.
                        Transaction Number - {{$route.params.transactionId}}
            </div>
            <div class="col-sm-6 col-md-8" v-else>
                Sorry! Your transaction could not be completed.
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="container">
          <div class="copyright">
           Copyright 2021 <span>NIRMAN</span> All rights reserved. <a href="https://nirman.mkcl.org/">Privacy Policy</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    name: 'paymentStatus',
    component: {
    },
    data () {
        return {

        }
    }
}
</script>


// WEBPACK FOOTER //
// paymentStatus.vue?5435c10d